import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M15.3 12C15.3 13.823 13.823 15.3 12 15.3C10.177 15.3 8.69995 13.823 8.69995 12C8.69995 10.177 10.177 8.69995 12 8.69995C13.823 8.69995 15.3 10.177 15.3 12Z"
      fill="currentColor"
    />
    <path
      d="M21 11H19.784C19.332 7.469 16.531 4.669 13 4.217V3C13 2.448 12.552 2 12 2C11.448 2 11 2.448 11 3V4.217C7.469 4.669 4.669 7.469 4.217 11H3C2.448 11 2 11.448 2 12C2 12.552 2.448 13 3 13H4.217C4.669 16.531 7.469 19.332 11 19.784V21C11 21.553 11.448 22 12 22C12.552 22 13 21.553 13 21V19.784C16.531 19.332 19.332 16.532 19.784 13H21C21.553 13 22 12.552 22 12C22 11.448 21.553 11 21 11ZM12 17.854C8.772 17.854 6.146 15.228 6.146 12C6.146 8.772 8.772 6.146 12 6.146C15.229 6.146 17.854 8.772 17.854 12C17.854 15.228 15.229 17.854 12 17.854Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'CrosshairFill');

export default Icon;
